export default __webpack_public_path__ + "static/media/frame-avatar.76a1b586.png";